import { createI18n } from 'vue-i18n';
import { watch } from 'vue';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';
import { countryState, identityFor } from './config/country';
import moment from 'moment';
import 'moment/locale/de';

// i18n setup
const messages = {
  en: {
    translation: { ...enTranslation }
  },
  de: {
    translation: { ...deTranslation }
  }
};

function detectBrowserLanguage() {
  const browserLang = navigator.language || navigator.userLanguage; // Get browser language, e.g., 'en-US' or 'de-DE'
  const shortLang = browserLang.split('-')[0]; // Extract the short form, e.g., 'en' or 'de'

  // Check if the detected language is available in `messages`
  return Object.keys(messages).includes(shortLang) ? shortLang : 'en'; // Fallback to 'en' if not supported
}

const currentLocale = localStorage.getItem('language') || detectBrowserLanguage();

moment.locale(currentLocale);

const i18n = createI18n({
  locale: currentLocale, // Use stored language or detect from browser
  fallbackLocale: 'en', // Fallback to English if language is unsupported
  messages,
});

// Merged into every locale so the display language cannot change the company identity.
function applyCountryIdentity(countryCode) {
  const identity = identityFor(countryCode);
  Object.keys(messages).forEach((locale) => {
    i18n.global.mergeLocaleMessage(locale, { translation: identity });
  });
}

applyCountryIdentity(countryState.code);
watch(() => countryState.code, applyCountryIdentity);

export default i18n;
